import { z } from 'zod';
import { SourceRefSchema, icon, sourceOf } from '../schema_fields.ts';

/**
 * A light (legacy `LightTile`; docs/specs/light-tile.md): its source is the device, its whole state
 * where the driver gives it (the light role's record: on, level, white tone, colour); a tap switches it on or off,
 * a hold opens its card. The icon, by its legacy or Font Awesome name, is in the light's colour
 * while it is on and grey while it is off.
 */
export const LightOptionsSchema = z.object({
    // A light: the device whole, as its role's record (device-roles.md DR-4); or only its on/off or level.
    source: sourceOf(SourceRefSchema, { gives: ['light', 'onOff', 'level'], label: 'Light' }),
    // `controls` (a button that opened the card) is gone: the level chip does it (light-tile.md LT-10); files that have it still read.
    icon: icon('Icon', 'lightbulb'),
});
